import { lazy } from 'react';
import { Casino } from '@mui/icons-material';
import type { ToolDefinition } from '../registry';

export const tirageAuSortTool: ToolDefinition = {
  id: 'tirage-au-sort',
  name: 'Tirage au sort',
  icon: Casino,
  basePath: '/tirage-au-sort',
  routes: [
    { path: '/tirage-au-sort', component: lazy(() => import('./pages/DrawListPage')) },
    { path: '/tirage-au-sort/nouveau', component: lazy(() => import('./pages/NewDrawPage')) },
    { path: '/tirage-au-sort/:id', component: lazy(() => import('./pages/DrawDetailPage')) },
  ],
};
